export default __webpack_public_path__ + "static/media/Honored Vambraces of the Seven Suns.d95f8b62.jpg";